import { addRelationStmtInstruction } from './AddRelationStmt';
import { onDeleteStmtInstruction } from './OnDeleteStmt';
import { removeRelationStmtInstruction } from './RemoveRelationStmt';
import { translatableRelationStmtInstruction } from './SetTranslatableRelationStmt';
export const relationshipInstruction = `
### Relationships

${addRelationStmtInstruction}
${removeRelationStmtInstruction}
${onDeleteStmtInstruction}
${translatableRelationStmtInstruction}

#### Important Note on Relationship Definition:

- The <owning_field> should describe the relationship from the point of view of the owning entity. Similarly, <inverse_field> should reflect the relationship from the side of the inverse entity, keep in mind, it must be unique name for given inverse entity
- Do not specify field names that directly point to attributes like 'name' or 'email'. Instead, specify the relationship field, like 'members', that reflects the essence of the relationship.

#### Relationship Categories

- \`one to many\`: Frequently employed. Use this to define relationships where multiple instances of Entity B relate to a single instance of Entity A.
- \`many to one\`: A common option. Ideal when several instances of Entity A link to a singular instance of Entity B.
- \`many to many\`: Deploy when a mutual relationship between multiple instances of both entities is required.
- \`one to one\`: Utilize judiciously. Only implement when it's unambiguously clear that a unique relationship exists between two entity instances.
- when possible, try to define "on delete" behaviour

#### Relationship examples

Incorrect: \`add relation Article.category one to one Category.name;\`
Correct: \`add relation Article.category many to one Category.articles;\``;
//# sourceMappingURL=relationshipInstruction.js.map